import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../../store";
import { UserMode } from "../../../../interfaces/User";
import { LeaveApplicationList } from "../../../AttendanceDashboard/LeaveApplication/LeaveApplicationList";

export default function UserLeaveApplications(): React.ReactNode {
  const userContext = useSelector((state: RootState) => state.userContext);

  return (
    <LeaveApplicationList
      createLeaveOnBehalfOfEmployee={false}
      enableCreateNew
      employeeIds={userContext.mode === UserMode.Employee ? [userContext.user.id] : []}
      serviceProviderIds={
        userContext.mode === UserMode.ServiceProvider ? [userContext.user.id] : []
      }
    />
  );
}
